import React from 'react';
import { Progress, ProgressFilledTrack } from '@gluestack-ui/themed';

const WordCountProgress = ({ wordcount, targetWordcount, wordcountColor }) => {
  if (targetWordcount <= 0) return null;
  const progressPercentage = Math.min((wordcount.bodyWords / targetWordcount) * 100, 100);
  return (
    <Progress value={progressPercentage} size="xs" h={2} bg="$borderLight100" testID="wordcount-progress-indicator">
      <ProgressFilledTrack bg={wordcountColor} />
    </Progress>
  );
};

export default WordCountProgress;
